class Dashboard {
    static register = {
        DBD_ORDER_SUMMARY: {slug: 'DBD_ORDER_SUMMARY'},
        DBD_QUOTES_SUMMARY: {slug:'DBD_QUOTES_SUMMARY'},
        DBD_REPORTS:{slug:'DBD_REPORTS'},
        DBD_NOTIFICATION:{slug:'DBD_NOTIFICATION'},
        DBD_BOM_SUMMARY:{slug:'DBD_BOM_SUMMARY'}
    };
}

export default Dashboard;